module.exports = __webpack_public_path__ + "static/media/add_user.9729a0da.svg";